window.updateCardVariant = function updateCardVariant(select) {
  const content = select.closest('.p-content');
  const option = select.options[select.selectedIndex];
  if (!content || !option) return;
  const input = content.querySelector('input[name="id"]');
  const price = content.querySelector('.p-btn-esho strong');
  const strike = content.querySelector('.p-strike-btn');
  const button = content.querySelector('.p-btn-esho');
  if (input) input.value = select.value;
  if (price) price.textContent = option.dataset.price;
  if (button && button.getAttribute('aria-busy') !== 'true') button.disabled = option.disabled;
  if (strike) {
    strike.textContent = option.dataset.compare || '';
    strike.style.display = option.dataset.compare ? 'inline-block' : 'none';
  }
};

if (!window.eshoCartSubmitBound) {
  window.eshoCartSubmitBound = true;
  document.addEventListener('submit', async function(event) {
    const form = event.target;
    if (!form.matches('.esho-ajax-form')) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled || form.dataset.submitting === 'true') return;
    const content = form.closest('.p-content') || form.parentElement;
    const select = content.querySelector('.p-variant-select');
    const input = form.querySelector('input[name="id"]');
    if (!input || (select && (!select.selectedOptions[0] || select.selectedOptions[0].disabled))) return;
    if (select) input.value = select.value;
    let errorMessage = content.querySelector('.p-card-error');
    if (!errorMessage) {
      errorMessage = document.createElement('p');
      errorMessage.className = 'p-card-error';
      errorMessage.setAttribute('role', 'alert');
      form.after(errorMessage);
    }
    errorMessage.hidden = true;
    const formData = new FormData(form);
    const selectDisabled = select?.disabled;
    form.dataset.submitting = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');
    if (select) select.disabled = true;
    let timer;
    try {
      const cart = document.querySelector('cart-drawer');
      if (cart) {
        await Promise.race([customElements.whenDefined('cart-drawer'), new Promise((_, reject) => {
          timer = setTimeout(() => reject(new Error(window.cartStrings.error)), 8000);
        })]);
        await cart.addItem(formData, { button, source: 'product-card' });
      } else {
        const response = await fetch(window.routes.cart_add_url.replace(/\.js$/, '') + '.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData
        });
        const result = await response.json();
        if (!response.ok || (result.status && Number(result.status) !== 200)) throw new Error(result.description || window.cartStrings.error);
        window.location.assign(window.routes.cart_url);
      }
    } catch (error) {
      errorMessage.textContent = error.message || window.cartStrings.error;
      errorMessage.hidden = false;
      try { publish(PUB_SUB_EVENTS.cartError, { source: 'product-card', productVariantId: formData.get('id'), errors: errorMessage.textContent, message: errorMessage.textContent }); } catch (_) {}
    } finally {
      clearTimeout(timer);
      delete form.dataset.submitting;
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');
      if (select) select.disabled = selectDisabled;
      button.disabled = select ? !!select.selectedOptions[0]?.disabled : false;
    }
  });
}

if (!window.eshoVideoHoverBound) {
  window.eshoVideoHoverBound = true;
  const hoverAllowed = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  let activeVideo;
  let activeCard;
  let requestId = 0;
  const stopPreview = () => {
    requestId++;
    if (!activeVideo) return;
    observer.unobserve(activeVideo);
    activeCard.classList.remove('p-preview-playing');
    activeVideo.pause();
    activeVideo.removeAttribute('src');
    activeVideo.load();
    activeVideo = activeCard = null;
  };
  const observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.target === activeVideo && !entry.isIntersecting)) stopPreview();
  });
  const startPreview = card => {
    const video = card?.querySelector('.p-hover-video');
    if (!video || video === activeVideo) return;
    stopPreview();
    if (!hoverAllowed.matches || document.hidden || navigator.connection?.saveData) return;
    activeVideo = video;
    activeCard = card;
    const request = requestId;
    video.muted = true;
    video.src = video.dataset.src;
    observer.observe(video);
    video.play().catch(() => {
      if (request === requestId) stopPreview();
    });
  };
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    const card = event.target.closest('[data-product-preview]');
    if (card && !card.contains(event.relatedTarget)) startPreview(card);
  });
  document.addEventListener('pointerout', event => {
    if (activeCard?.contains(event.target) && !activeCard.contains(event.relatedTarget)) stopPreview();
  });
  document.addEventListener('focusin', event => {
    if (event.target.matches('[data-product-preview-media]')) startPreview(event.target.closest('[data-product-preview]'));
  });
  document.addEventListener('focusout', event => {
    if (event.target.matches('[data-product-preview-media]')) stopPreview();
  });
  document.addEventListener('playing', event => {
    if (event.target === activeVideo) activeCard.classList.add('p-preview-playing');
  }, true);
  document.addEventListener('error', event => {
    if (event.target === activeVideo) stopPreview();
  }, true);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stopPreview();
  });
  document.addEventListener('shopify:section:unload', stopPreview);
  window.addEventListener('pagehide', stopPreview);
  hoverAllowed.addEventListener('change', stopPreview);
}
